import posthog from 'posthog-js'

import { getPosthogProxyPath } from './posthog-proxy-path'
import { takeAddressCorrectionSecret } from '@/utilities/addressCorrectionSecret'
import { registerAppSuperProperties } from '@/utilities/analytics/userAnalytics'
import {
  hasPersistedFixDataUrl,
  redactCapturedNetworkRequest,
  sanitizePosthogEventUrls,
} from '@/utilities/posthog/sanitizeEventUrls'

// Runs before PostHog reads the page URL, so the address-correction secret never reaches an event or storage.
takeAddressCorrectionSecret()

if (process.env.NEXT_PUBLIC_ENABLE_ANALYTICS === 'true') {
  const proxyPath = getPosthogProxyPath()
  const apiHost = `/${proxyPath}`
  const hadPersistedFixDataUrl = hasPersistedFixDataUrl()

  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: apiHost,
    ui_host: 'https://us.posthog.com',
    defaults: '2025-05-24',
    cross_subdomain_cookie: false,
    enable_recording_console_log: true,
    // Strip Stytch auth tokens from Ash portal URLs before events leave the browser
    before_send: sanitizePosthogEventUrls,
    // mask passwords but keep other inputs
    session_recording: {
      // Strips the fix-data secret and Stytch tokens from captured request URLs
      maskCapturedNetworkRequestFn: redactCapturedNetworkRequest,
      maskAllInputs: true,
      maskInputFn: (text, element) => {
        if (
          element instanceof HTMLInputElement &&
          // Mask password fields and the text version when toggling password visibility
          (element.type === 'password' ||
            element.name === 'password' ||
            element.id === 'password' ||
            element.id === 'password-input')
        ) {
          return '*'.repeat(text.length)
        }
        if (
          element instanceof HTMLInputElement &&
          // Mask Stytch MFA fields
          element.autocomplete === 'one-time-code'
        ) {
          return '*'.repeat(text.length)
        }
        return text
      },
      // Mask Stytch MFA fields (web component + v22 light DOM under .stytch-wrapper)
      maskTextSelector: [
        'stytch-b2b-ui [data-testid^="otp-"]',
        'stytch-b2b-ui [data-input-otp-container]',
        'stytch-b2b-ui img[alt="QR code for TOTP enrollment"]',
        'stytch-b2b-ui code span',
        '.stytch-wrapper [data-testid^="otp-"]',
        '.stytch-wrapper [data-input-otp-container]',
        '.stytch-wrapper img[alt="QR code for TOTP enrollment"]',
        '.stytch-wrapper code span',
        '.stytch-wrapper [class*="CodeContainer_module_container"]',
      ].join(', '),
    },
    autocapture: true,
  })

  // Storage from before the strip could still hold a fix-data URL. `reset` clears it, and it also clears super properties.
  if (hadPersistedFixDataUrl) {
    posthog.reset()
  }
  registerAppSuperProperties()
}
